import React from 'react';

interface TabContentProps {
    active?: boolean;
    enabled?: boolean;
    label: string;
    children: any;
}

const TabContent: React.FC<TabContentProps> = ({ active = false, enabled = true, label = null, children }) => {
    return null;
};

export default TabContent;



// WEBPACK FOOTER //
// ./src/components/Tabs/TabContent.tsx